import BaseApi from './base'

class HelpDeskQuestion extends BaseApi {
  getHelpDesks = (query) => this.client.get(`admin/help-desk-button?${query}`)

  getHelpDesk = (id) => this.client.get(`admin/help-desk-button/${id}`)

  addHelpDesk = (data) => this.client.post('admin/help-desk-button', data)

  updateHelpDesk = ({ helpDeskId, payload }) =>
    this.client.patch(`admin/help-desk-button/${helpDeskId}`, payload)

  deleteHelpDesk = (id) => this.client.delete(`admin/help-desk-button/${id}`)

  upsertHelpDeskContentTranslation = ({ helpDeskId, languageId, payload }) =>
    this.client.post(
      `admin/help-desk-button/${helpDeskId}/translation/${languageId}`,
      payload
    )
}

export default new HelpDeskQuestion()
